function bar() {
    console.log('bars');
}
